import Vue from 'vue';
import { CollapsePlugin } from 'bootstrap-vue';
import StarRating from '@/components/StarRating.vue';
import { initVue } from '@/vue';
import { useDialog } from '@/composables/useDialog';

const dialogManager = useDialog();

Vue.use(CollapsePlugin);

dialogManager.register({
	'email-business': () => import('@/includes/forms/EmailBusiness.vue'),
})

initVue({
	components: {
		'star-rating': StarRating,
	}
})

